import React, { useState, useEffect, useRef } from "react";
import "./Testimonials.css";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  const timeoutRef = useRef(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setTestimonials(data.testimonials || []);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);


  const totalSlides = testimonials.length;


  const goTo = (newIdx) => {
    setVisible(false);

    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setIdx(newIdx);
      setVisible(true);
    }, 350);
  };


  const prev = () => {
    if (totalSlides === 0) return;

    goTo(idx === 0 ? totalSlides - 1 : idx - 1);
  };


  const next = () => {
    if (totalSlides === 0) return;

    goTo(idx === totalSlides - 1 ? 0 : idx + 1);
  };


  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);


  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }


  if (testimonials.length === 0) {
    return null;
  }


  const testimonial = testimonials[idx];


  return (
    <section className="testi-section section-pad" id="testimonials">
      <div className="container">

        <h2 className="testi-heading" data-aos="fade-up">
          Hear from Our Satisfied Clients
        </h2>


        <div
          className="testi-row"
          data-aos="fade-up"
          data-aos-delay="100"
        >

          {/* Left Arrow */}
          <button
            className="testi-arrow"
            onClick={prev}
            aria-label="Previous"
          >
            <i className="bi bi-arrow-left"></i>
          </button>


          {/* Single Testimonial */}
          <div
            className={`testi-body ${visible ? "testi-visible" : "testi-hidden"
              }`}
          >

            <div className="testi-quote-icon">
              <i className="bi bi-quote"></i>
            </div>


            <p className="testi-text">
              {testimonial.description}
            </p>


            <h5 className="testi-name">
              {testimonial.name}
            </h5>


            <p className="testi-role">
              {testimonial.designation}
            </p>

          </div>


          {/* Right Arrow */}
          <button
            className="testi-arrow"
            onClick={next}
            aria-label="Next"
          >
            <i className="bi bi-arrow-right"></i>
          </button>

        </div>

      </div>
    </section>
  );
}